export const BOOKMARK_SIDE_DATA = [
  {
    value: "1",
    title: "Created By Me",
  },
  {
    value: "2",
    title: "Favourites",
  },
  {
    value: "3",
    title: "Shared With Me",
  },
  {
    value: "4",
    title: "My Bookmark",
  },
];

export const BOOKMARK_TAG_DATA = [
  {
    value: "5",
    title: "Notification",
  },
  {
    value: "6",
    title: "Newsletter",
  },
  {
    value: "7",
    title: "Business",
  },
  {
    value: "8",
    title: "Holidays",
  },
  {
    value: "9",
    title: "Important",
  },
  {
    value: "10",
    title: "Orgenization",
  },
];

export const BOOKMARK_DATA = [
  {
    id: 1,
    fillStar: false,
    image: "lightgallry/01.jpg",
    title: "Admin Template",
    website_url: "http://admin.pixelstrap.com//ltr/landing-page.html",
    desc: "is beautifully crafted, clean and modern designed admin theme with 6 different demos and light - dark versions.",
    collection: "General",
  },
  {
    id: 2,
    fillStar: false,
    image: "lightgallry/02.jpg",
    title: "Universal Template",
    website_url: "https://angular.pixelstrap.com/universal/landing",
    desc: "Universal is beautifully crafted, clean and modern designed admin theme",
    collection: "General",
  },
  {
    id: 3,
    fillStar: false,
    image: "lightgallry/03.jpg",
    title: "Angular Theme",
    website_url: "https://angular.pixelstrap.com/boho/landing",
    desc: "Boho is beautifully crafted, clean and modern designed admin theme",
    collection: "Fs",
  },
  {
    id: 4,
    fillStar: false,
    image: "lightgallry/04.jpg",
    title: "Multikart Admin",
    website_url: "http://themes.pixelstrap.com/multikart/back-end/index.html",
    desc: "Multikart Admin is modern designed admin theme",
    collection: "General",
  },
  {
    id: 5,
    fillStar: false,
    image: "lightgallry/05.jpg",
    title: "Ecommerece theme",
    website_url: "http://themes.pixelstrap.com/multikart",
    desc: "Multikart HTML template is an apparently simple but highly functional tempalate designed for creating a flourisahing online business.",
    collection: "General",
  },
  {
    id: 6,
    fillStar: false,
    image: "lightgallry/06.jpg",
    title: "Tovo app landing page",
    website_url: "http://vue.pixelstrap.com/tovo/home-one",
    desc: "Amazing Landing Page With Easy Customization",
    collection: "Fs",
  },
];